import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, RegisteredClientResponseDTO } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class AddCurrentAccountCommand extends IRequestCommand<
  IAddCurrentAccountResponse,
  ErrorDetails,
  IAddCurrentAccountCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl =
    'carriers/{carrierUserId}/passenger/{passengerUserId}/checkingAccount';
  override _needAuthenticate = true;
  public override setParameters(parameters: IAddCurrentAccountCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.passengerUserId.toString()
    );
  }
}

export interface IAddCurrentAccountCommandParameters
  extends ICommandParameters {
  carrierUserId?: string;
  passengerUserId?: number;
}

export interface IAddCurrentAccountResponse
  extends RegisteredClientResponseDTO,
    ICommandResponse {}
